const AUTH_CONFIG_URL = `${process.env.PUBLIC_URL || ''}/auth-config.json`

const resolveRedirectUri = (redirectUri, defaultPath) => {
  if (!redirectUri) {
    return `${window.location.origin}${defaultPath}`
  }

  return new URL(redirectUri, window.location.origin).toString()
}

const validateMsalConfig = (msalConfig) => {
  if (!msalConfig || typeof msalConfig !== 'object') {
    throw new Error('La section "msal" est absente du fichier auth-config.json')
  }

  if (!msalConfig.clientId) {
    throw new Error('La valeur "msal.clientId" est obligatoire')
  }

  if (!msalConfig.authority) {
    throw new Error('La valeur "msal.authority" est obligatoire')
  }
}

const normalizeRuntimeAuthConfig = (runtimeConfig) => {
  validateMsalConfig(runtimeConfig.msal)

  return {
    msal: {
      ...runtimeConfig.msal,
      redirectUri: resolveRedirectUri(
        runtimeConfig.msal.redirectUri,
        '/auth/oidc'
      ),
      boRedirectUri: resolveRedirectUri(
        runtimeConfig.msal.boRedirectUri,
        '/bo/auth/oidc'
      ),
      postLogoutRedirectUri: runtimeConfig.msal.postLogoutRedirectUri || '/',
      navigateToLoginRequestUrl:
        runtimeConfig.msal.navigateToLoginRequestUrl ?? false,
    },
  }
}

export const loadRuntimeAuthConfig = async () => {
  try {
    const response = await fetch(AUTH_CONFIG_URL, { cache: 'no-store' })

    if (response.status === 404) {
      return null
    }

    if (!response.ok) {
      throw new Error(
        `Impossible de charger ${AUTH_CONFIG_URL} (${response.status})`
      )
    }

    const rawConfig = await response.text()
    const trimmedConfig = rawConfig.trim()

    if (!trimmedConfig || trimmedConfig.startsWith('<')) {
      return null
    }

    return normalizeRuntimeAuthConfig(JSON.parse(trimmedConfig))
  } catch (error) {
    if (error instanceof SyntaxError) {
      throw new Error('Le fichier auth-config.json contient un JSON invalide')
    }

    if (error instanceof Error) {
      throw error
    }

    throw new Error(`Impossible de charger ${AUTH_CONFIG_URL}`)
  }
}

